import { createAction } from 'shared/utils';

export const CONFIG_BLOCK_PAGE_REFRESH = 'CONFIG_BLOCK_PAGE_REFRESH';
export const CONFIG_BLOCK_SUBDIVISION_GETS = createAction('CONFIG_BLOCK_SUBDIVISION_GETS');
export const CONFIG_BLOCK_GETS = createAction('CONFIG_BLOCK_GETS');
export const CONFIG_BLOCK_ADD = createAction('CONFIG_BLOCK_ADD');
export const CONFIG_BLOCK_UPDATE = createAction('CONFIG_BLOCK_UPDATE');
export const CONFIG_BLOCK_DELETE = createAction('CONFIG_BLOCK_DELETE');
